// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const YOU_DO_NOT_HAVE_ACTIVE_PLAN = "Z\u00edskej";
